<template>
  <div class="ui left aligned container">
    <div class="flex">
      <div class="ui icon input">
        <input type="text" v-model="name">
        <i v-if="name" class="circular close link icon" @click="name=''"></i>
        <i v-else class="inverted circular search link icon"></i>
      </div>
      <div class="right">
        <button @click="refresh" class="ui icon button"><i class="sync icon"></i></button>
        <button @click="addEpisode" class="ui icon button"><i class="add icon"></i></button>
        <button @click="modalBatch=true" class="ui icon button"><i class="upload icon"></i></button>
      </div>
    </div>

    <vuetable ref="vuetable" :api-url="'/episodes?name='+name" :fields="fields" per-page="20"
              @vuetable:pagination-data="onPaginationData">
      <template slot="actions" scope="props">
        <i class="edit link icon" title="编辑" @click="editEpisode(props.rowData)"></i>
        &nbsp;&nbsp;
        <i class="trash alternate outline link icon" title="删除" @click="deleteEpisode(props.rowData)"></i>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>

    <Modal v-model="modal">
      <template slot="title">
        {{ title }}
      </template>
      <form class="ui form">
        <div class="field">
          <label>名称</label>
          <input name="name" type="text" v-model="form.name">
        </div>
        <div class="field">
          <label>集数</label>
          <input name="episode" type="number" min="1" v-model="form.episode">
        </div>
        <div class="field">
          <label>播放地址</label>
          <input name="url" type="url" v-model="form.url">
        </div>
        <div class="inline field">
          <input type="checkbox" v-model="form.vip">
          <label>VIP</label>
        </div>
        <div class="inline field">
          <input type="checkbox" v-model="form.pay">
          <label>超点</label>
        </div>
      </form>
      <template slot="actions">
        <div @click="modal=false" class="ui cancel button">取消</div>
        <div @click="onSubmit" class="ui positive button">保存</div>
      </template>
    </Modal>

    <Modal v-model="modalBatch" title="批量添加">
      <form class="ui form">
        <div class="field">
          <label>名称</label>
          <input name="name" type="text" v-model="batch.name">
        </div>
        <div class="inline field">
          <input type="checkbox" v-model="batch.vip">
          <label>VIP</label>
        </div>
        <div class="inline field">
          <input type="checkbox" v-model="batch.pay">
          <label>超点</label>
        </div>
        <div class="field">
          <label>播放地址</label>
          <textarea name="urls" v-model="batch.urls" rows="25" cols="50"></textarea>
        </div>
      </form>
      <template slot="actions">
        <div @click="modalBatch=false" class="ui cancel button">取消</div>
        <div @click="addBatch" class="ui positive button">保存</div>
      </template>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import Vuetable from "@/table/Vuetable.vue";
import RadioBox from "@/components/RadioBox.vue";
import VuetablePagination from "@/table/VuetablePagination.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "Episode",
  components: {
    Vuetable,
    VuetablePagination,
    RadioBox,
    Modal
  },
  data() {
    return {
      modal: false,
      modalBatch: false,
      title: '',
      name: '',
      form: {
        id: 0,
        name: '',
        episode: 1,
        url: '',
        vip: false,
        pay: false,
      },
      batch: {
        name: '',
        urls: '',
        vip: false,
        pay: false,
      },
      fields: [
        {name: 'id', title: 'ID'},
        {name: 'name', title: '名称'},
        {name: 'episode', title: '集数'},
        {name: 'url', title: '播放地址', callback: 'url'},
        {name: 'vip', title: 'VIP'},
        {name: 'pay', title: '超点'},
        {name: '__slot:actions', title: '操作'}
      ],
    }
  },
  methods: {
    refresh() {
      this.$refs.vuetable.reload();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage(page) {
      if (page === 'prev') {
        this.page--
      } else if (page === 'next') {
        this.page++
      } else {
        this.page = parseInt(page)
      }
      this.$refs.vuetable.changePage(page)
    },
    url(value) {
      return `<a href="${value}" target="_blank">${value}</a>`
    },
    addBatch() {
      const data = Object.assign({}, this.batch)
      data.urls = data.urls.trim().split('\n')
      axios.post('/episodes/add', data).then(() => {
        this.modalBatch = false
        this.batch = {
          name: '',
          urls: ''
        }
        this.refresh();
      });
    },
    addEpisode() {
      this.title = '添加'
      this.form = {
        id: '',
        name: '',
        episode: 1,
        url: '',
        vip: false,
        pay: false,
      }
      this.modal = true
    },
    editEpisode(data) {
      this.title = '更新'
      this.form = data
      this.modal = true
    },
    onSubmit() {
      axios.post('/episodes/' + this.form.id, this.form).then(() => {
        this.modal = false
        this.refresh();
      });
    },
    deleteEpisode(data) {
      axios.delete('/episodes/' + data.id).then(() => {
        this.refresh();
      })
    }
  }
}
</script>

<style scoped>
.flex {
  display: flex;
}

.flex .right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: auto !important;
}
</style>